import BugsnagBrowserPerformance from '@bugsnag/browser-performance'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  BugsnagBrowserPerformance.start({
    apiKey: runtimeConfig.public.NUXT_BUGSNAG_API_KEY,
  })
})
